export const CLOSED = null;
export const CONFIRM_DELETION = 1;
export const SET_IMAGE_TYPE = 2;